export default "__VITE_ASSET__6455e2a9__"